import React from 'react';
import { useLazyQuery } from 'apollo-client-ppc';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/cssxp-client-utils';
import { fetchContactDetailsFromContactService } from './queries/fetch-contact-details-from-contact-service';
import { ContactType, getResourceAri } from './constant';

export const useFetchBillingContactsFromContactService = () => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);

  const [fetchBilingContactDetails, { loading: billingContactsLoading, error: billingContactsError }] = useLazyQuery(
    fetchContactDetailsFromContactService,
    {
      client: ansClient as any,
    }
  );

  const getBillingContactDetails = async (invoiceGroupId: string, transactionAccountId: string) => {
    const { data } = await fetchBilingContactDetails({
      variables: {
        resourceAri: getResourceAri(transactionAccountId, invoiceGroupId),
        contactType: [ContactType.BILLING_CONTACT],
        transactionAccountId: transactionAccountId,
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    });

    return data?.contactsByResource?.filter((contact: any) => contact.accountId && (contact.email || contact.name));
  };

  return {
    getBillingContactDetails,
    billingContactsLoading,
    billingContactsError,
  };
};
